import React, { FunctionComponent } from 'react';
import { BrandOther } from '../brandOther';
import type { ShowBrandCompany } from '../../../types/brand';

type Props = {
  isAllStoppedRecruitments: boolean;
  brandId: number;
  instagramIcon: string;
  noimage: string;
  hoverIcon: string;
  isPc: boolean;
  companyData: ShowBrandCompany;
  dataCategory: {
    brandcontent: string;
    stopbrandcontent: string;
  };
  dataValue: any;
};

export const Presentation: FunctionComponent<Props> = ({
  isAllStoppedRecruitments,
  brandId,
  instagramIcon,
  noimage,
  hoverIcon,
  isPc,
  companyData,
  dataValue,
  dataCategory,
}) => {
  return (
    <section className="brand-about-company">
      <div className="brand-about-company__container">
        <h2 className="brand-about-company__container--title">会社情報</h2>
        <div className="brand-about-company__table">
          {companyData.name && (
            <div className="brand-about-company__table--row name">
              <div className="brand-about-company__table--header">会社名</div>
              <a
                href={`/companies/${companyData.id}`}
                className="brand-about-company__table--data gtm-company_info-view-count"
                data-event-name='company_info on screen'
                data-event="click"
                data-category={isAllStoppedRecruitments ? dataCategory.stopbrandcontent : dataCategory.brandcontent}
                data-value={dataValue.companyName}
              >
                {companyData.name}
              </a>
            </div>
          )}
          {companyData.shihonkin && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">資本金</div>
              <div className="brand-about-company__table--data">{companyData.shihonkin}</div>
            </div>
          )}
          {companyData.setsuritsunengetsu && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">設立年</div>
              <div className="brand-about-company__table--data">{companyData.setsuritsunengetsu}</div>
            </div>
          )}
          {companyData.daihyoshaname && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">代表者</div>
              <div className="brand-about-company__table--data">{companyData.daihyoshaname}</div>
            </div>
          )}
          {companyData.jugyoinsu && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">従業員数</div>
              <div className="brand-about-company__table--data">{companyData.jugyoinsu}</div>
            </div>
          )}
          {companyData.honshashozaichi && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">本社所在地</div>
              <div className="brand-about-company__table--data">{companyData.honshashozaichi}</div>
            </div>
          )}
          {companyData.industries && companyData.industries.length > 0 && (
            <div className="brand-about-company__table--row">
              <div className="brand-about-company__table--header">業種</div>
              <div className="brand-about-company__table--data">
                {companyData.industries && companyData.industries.map((industry) => industry.jpName).join(' / ')}
              </div>
            </div>
          )}
        </div>
      </div>
      {!isAllStoppedRecruitments && (
        <BrandOther
          brandId={brandId}
          instagramIcon={instagramIcon}
          noimage={noimage}
          hoverIcon={hoverIcon}
          isPc={isPc}
          dataCategory={isAllStoppedRecruitments ? dataCategory.stopbrandcontent : dataCategory.brandcontent}
          dataValue={dataValue}
        />
      )}
    </section>
  );
};
